<template>
    <div>
        <CompetitionSystem
            :offers="offers"
            :isSupplier="isSupplier"
            :subscription="subscription"
            :dummyCards="dummyCards"
            :loadingOffers="loadingOffers"
            :loadingMoreOffers="loadingMoreOffers"
            :offersTotal="offersTotal"
            @remove-opportunity="$emit('remove-opportunity', $event)"
        />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import CompetitionSystem from '@/components/supplier/competition-dashboard/competition-system';
export default {
    name: 'Dashboards',
    props: {
        isSupplier: Boolean,
        offersTotal: Number,
        loadingOffers: Boolean,
        loadingMoreOffers: Boolean,
        subscription: Object,
        offers: Array,
        offersOpportunity: Array,
        dummyCards: Number,
        showTabs: {
            default: true,
            type: Boolean
        }
    },
    components: { CompetitionSystem },
    data: () => ({
        isMobile: false
    }),
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
        });
        vue.isMobile = window.innerWidth <= 768;
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('user', ['supplierData']),
        tabsTitles() {
            return [
                { title: 'Sistemas de Cotações', new: false },
                {
                    title: 'Engelink Marketing',
                    new: this.user.type.hasSubscription && this.supplierData.engelinkMarketingVisualized
                }
            ];
        },
        titleAlignment() {
            return this.isMobile ? 'center' : 'flex-start';
        }
    }
};
</script>

<style>
@media screen and (max-width: 1920px) {
    .engelink_marketing-card-component.offer-card {
        flex: 1 0 calc((100% / var(--cards-per-row)) - var(--cards-margin));
    }
}
@media screen and (max-width: 1366px) {
    .card-wrapper {
        --card-width: 350px;
    }
    .engelink_marketing-card-component.offer-card {
        flex: 1 0 calc((100% / var(--cards-per-row)) - var(--cards-margin));
    }
}

@media screen and (max-width: 992px) {
    .engelink_marketing-card-component.offer-card {
        flex: 1 0 calc((100% / var(--cards-per-row)) - var(--cards-margin));
    }
}
</style>
